import styled from "styled-components";
import { Link } from "react-router-dom";

export const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #f5e6d3 0%, #f9f5f0 100%);
  position: relative;
  overflow-x: hidden;
`;

export const HeroSection = styled.section`
  position: relative;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("/images/product-hero-bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(245, 230, 211, 0.85);
    z-index: 1;
  }
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 60px 20px;
`;

export const BackLink = styled(Link)`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 3;
  color: #6d4c41;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;

  &:hover {
    color: #4a5d23;
    transform: translateX(-5px);
  }

  &::before {
    content: "←";
    margin-right: 8px;
    font-size: 18px;
  }
`;

export const ContentSection = styled.section`
  position: relative;
  padding: 80px 0;
  background-image: url("/images/pattern-bg.png");
  background-repeat: repeat;
  background-size: 600px;
  background-position: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(249, 245, 240, 0.95);
  }
`;

export const Container = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;

  @media screen and (min-width: 960px) {
    display: grid;
    grid-template-columns: 1fr 380px;
    gap: 60px;
  }
`;

export const MainContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 50px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);

  @media screen and (max-width: 959px) {
    padding: 30px;
    margin-bottom: 40px;
  }
`;

export const SideContent = styled.div`
  position: sticky;
  top: 20px;
  height: fit-content;
`;

export const ProductTitle = styled.h1`
  font-family: "Noto Serif JP", serif;
  font-size: 36px;
  color: #3e2723;
  margin-bottom: 10px;
  letter-spacing: 2px;
  font-weight: 400;
`;

export const ProductSubtitle = styled.h2`
  font-family: "Noto Sans JP", sans-serif;
  font-size: 16px;
  color: #6d4c41;
  font-weight: 400;
  letter-spacing: 1px;
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e8ddd5;
`;

export const SectionTitle = styled.h3`
  font-family: "Noto Serif JP", serif;
  font-size: 24px;
  color: #3e2723;
  margin: 40px 0 20px 0;
  display: flex;
  align-items: center;

  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 24px;
    background: #4a5d23;
    margin-right: 12px;
  }
`;

export const SubSectionTitle = styled.h4`
  font-family: "Noto Sans JP", sans-serif;
  font-size: 18px;
  color: #4a5d23;
  margin: 30px 0 15px 0;
  font-weight: 500;
`;

export const Paragraph = styled.p`
  color: #6d4c41;
  line-height: 1.8;
  margin-bottom: 15px;
`;

export const InfoTable = styled.table`
  width: 100%;
  margin: 20px 0;
  border-collapse: separate;
  border-spacing: 0;
  background: #fafaf8;
  border-radius: 8px;
  overflow: hidden;
`;

export const TableRow = styled.tr`
  &:not(:last-child) td {
    border-bottom: 1px solid #e8ddd5;
  }
`;

export const TableHead = styled.th`
  background: #4a5d23;
  color: #f5e6d3;
  padding: 12px 20px;
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1px;
`;

export const TableData = styled.td`
  padding: 15px 20px;
  color: #3e2723;
`;

export const TableDataLabel = styled.td`
  padding: 15px 20px;
  color: #6d4c41;
  font-weight: 500;
  width: 180px;
  background: #f9f5f0;
`;

export const NumberData = styled.td`
  padding: 15px 20px;
  text-align: right;
  color: #3e2723;
  font-family: "Roboto Mono", monospace;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 20px 0;
  text-align: left;

  li {
    position: relative;
    padding-left: 24px;
    margin-bottom: 12px;
    color: #6d4c41;
    line-height: 1.6;
    text-align: left;

    &::before {
      content: "•";
      position: absolute;
      left: 0;
      color: #4a5d23;
      font-size: 20px;
      line-height: 1;
    }
  }
`;

export const AcoContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  text-align: center;

  img {
    max-width: 100%;
    height: auto;
    margin: 20px 0;
  }

  /* Ensure lists maintain left alignment even in centered container */
  ul, ol {
    text-align: left;
  }

  h3 {
    font-family: "Noto Serif JP", serif;
    font-size: 20px;
    color: #4a5d23;
    margin-bottom: 15px;
  }

  p {
    color: #6d4c41;
    font-size: 14px;
    line-height: 1.6;
  }
`;

export const DecorativeElement = styled.div`
  position: absolute;
  width: 100px;
  height: 100px;
  background-image: url("/images/botanical-accent.png");
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.1;
  pointer-events: none;

  &.top-right {
    top: 20px;
    right: 20px;
  }

  &.bottom-left {
    bottom: 20px;
    left: 20px;
    transform: rotate(180deg);
  }
`;
